/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ProjectCtrl', function(
    $filter,
    $scope,
    $routeParams,
    $location,
    $window,
	$timeout,
    ErrorThrower,
    project,
    identity,
    Activity,
    Event,
    intraprof_web_url
) {
    const errorManager = new ErrorThrower();

    $scope.me             = identity;
    $scope.project        = project;
    $scope.stage          = { };
    $scope.is_adm         = Array.from($scope.me.groups).includes('adm');
    $scope.min_height     = $(window).height();
    $scope.project.events = { };
    $scope.reader_opened  = false;
    $scope.file           = { };

    $scope.current_stage  = null;
	$scope.current_stage_name = null;
    $scope.activity_infos = angular.copy($routeParams);
    $scope.params         = {
        module_id:   $scope.activity_infos.session_id,
        activity_id: $scope.activity_infos.activity_id
    };

    $scope.profs = Activity.profs($routeParams).$promise;

    // on load les non-inscrits du projet
    $scope.loadUnsubscribed = () => Activity.unsubscribe($routeParams)
        .$promise
        .then(unsubscribed_students => $scope.unsubscribed = unsubscribed_students).catch(function(error) {
            if (404 !== error.status) {
                errorManager.minor(error.statusText);
            }
    });

    $scope.loadUnsubscribed();

    $scope.$on('reloadUnsubscribed', event => $scope.loadUnsubscribed());

    Event
        .getEventForActivity({
            session_id:  $routeParams.session_id,
            activity_id: project.id,
            login:       identity.login}).$promise
        .then(event_date => $scope.project.events = angular.extend($scope.project.events, { events_list: event_date }))
        .catch(error => errorManager.minor(error.statusText));

    if ('quest' === $scope.project.type) {
		$scope.current_stage_name = $location.search().stage;
        Activity
        .stages({
            session_id:  $routeParams.session_id,
            activity_id: project.id
		}).$promise
        .then(function(stages) {
            $scope.project.events = angular.extend($scope.project.events, { stages });
			const stage = $scope.project.events.stages.filter(
				event => event.name === $location.search().stage
			).pop();
            $scope.current_stage = stage;
		})
		.catch(function(error) {
            if (403 !== error.status) {
                errorManager.minor(error.statusText);
            }
        });
    }

    $scope.projectOver = () => $scope.project.date_end < moment().format('YYYY-MM-DD HH:mm:ss');

    $scope.toggleReader = function(file) {
        if ((false === $scope.reader_opened) && (file != null)) { $scope.file = file; }
        return $scope.reader_opened = !$scope.reader_opened;
    };

    return $scope.$on('file_reader', function(event, file) {
        if (false === $scope.reader_opened) { return $scope.toggleReader(file);
        } else { return $scope.$broadcast('file_update', file); }
    });
});
